module.exports = __webpack_public_path__ + "static/img/9.7dd32a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/9.png
// module id = 7vsR
// module chunks = 0